<template>
  <div>
    <div class="section" style="width: 1700px">
      <div class="app-main-inner-row operations">
        <div v-show="cooperateEdit" class="triggers">
          <div>
            <el-button :disabled="isEdit" no="exportPackingInfo" type="primary" @click="exportTruckExcelData">{{ $t('SeaExport.ExportPackingInfo') }}
            </el-button>
            <el-upload
              :disabled="isEdit || job.jobState > 0"
              action="string"
              :http-request="importTruckDataExcel"
              :show-file-list="false"
              accept=".xls, .xlsx"
              :before-upload="beforeUploadUsage"
              style="display: inline-block;padding-left: 5px;"
            >
              <el-button no="importPackingInfo" type="primary" :disabled="isEdit || job.jobState > 0">
                {{ $t('SeaExport.ImportPackingInfo') }}
              </el-button>
            </el-upload>
            <el-button no="exportErrorExcel" type="primary" :disabled="isEdit && !importExcelResultID" @click="exportErrorExcel">{{ $t('SeaExport.DownloadImportResults') }}
            </el-button>
          </div>
        </div>
      </div>
      <div style="flex-grow:1;padding:10px">
        <cargo-ag-grid
          no="gridCabinets"
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="cabinetColumnDefs"
          :row-data="job.containerUsages || []"
          style="width:100%;height:300px"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <span class="title">{{ $t('SeaExport.DoorToDoorLoading') }} <span style="color: red; font-weight:lighter;margin:30px;">{{ $t('SeaExport.SaveBusinessBeforeEnterMultiGate2') }}</span></span>
      <div style="display:flex;">
        <div style="display:flex;flex-direction:column">
          <el-form :inline="true" class="inline-form" label-width="100px" label-position="left">
            <el-form-item style="width: 460px">
              <el-checkbox v-model="truckingInfo.sameTransportationCompany" no="5.1" :disabled="readonly" style="width: auto;">{{
                $t('SeaExport.SameTransportationCompany') }}
              </el-checkbox>
              <el-checkbox v-model="truckingInfo.sameDoorPoint" no="5.2" :disabled="readonly" style="width: auto;">
                {{ $t('SeaExport.SameDoorPoint') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <label style="width: 55px">{{ $t('SeaExport.Quantity') }}</label>
              <el-input-number
                no="6"
                :value="truckingInfo.quantity||undefined"
                :disabled="readonly"
                :min="0"
                :max="99999"
                :precision="0"
                controls-position="right"
                style="width: 100px"
                @input="event => truckDataChange(event, 'quantity')"
              />
              <label style="width: 55px">{{ $t('SeaExport.Weight') }}</label>
              <el-input-number
                no="7"
                :value="truckingInfo.weight||undefined"
                :disabled="readonly"
                :min="0"
                :max="99999"
                :precision="3"
                controls-position="right"
                style="width: 100px"
                @input="event => truckDataChange(event, 'weight')"
              />
              <label style="width: 55px">{{ $t('SeaExport.Cubage') }}</label>
              <el-input-number
                no="8"
                :value="truckingInfo.cubage||undefined"
                :disabled="readonly"
                :min="0"
                :max="99999"
                :precision="3"
                controls-position="right"
                style="width: 100px"
                @input="event => truckDataChange(event, 'cubage')"
              />
            </el-form-item>
          </el-form>

          <div class="trucking-form">
            <el-form :disabled="readonly" label-width="140px" label-position="left">
              <el-form-item :label="$t('SeaExport.HaulageCompany')" class="custom">
                <cargo-company-select
                  no="9"
                  :disabled="readonly"
                  :method-params="{truckCmp:true,active:true}"
                  :default-value="truckingInfo.carryingCmp||''"
                  style="width:350px; display:inline-block"
                  @change="p=>{truckingInfo.carryingCmp=p.value||0;carryingCmpChangeHandler()}"
                />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.HaulageContactPerson')" class="custom">
                <el-select
                  v-model="truckingInfo.driver"
                  no="10"
                  style="width:350px"
                  :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                  :allow-create="true"
                  :clearable="true"
                  filterable
                  @change="carryingContactsChangeHandler(false, false)"
                  @blur="selectContactBlur"
                >
                  <el-option
                    v-for="(item,index) in carryingContacts"
                    :key="index"
                    :label="item.contactPerson"
                    :value="item.contactPerson"
                  />
                </el-select>
              </el-form-item>

              <el-form-item class="custom" :label="$t('SeaExport.EstimatedPackingDate')">
                <el-date-picker
                  v-model="truckingInfo.loadingDate"
                  no="11"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width:350px"
                  @input="event => truckDataChange(event, 'loadingDate')"
                />
              </el-form-item>
              <el-form-item class="custom" :label="$t('SeaExport.ExpectedArrivalDate2')">
                <el-date-picker
                  v-model="ieTruckInfo.arriveDate"
                  no="arrivalDate"
                  :disabled="true"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width:350px"
                />
              </el-form-item>
              <el-form-item :label="$t('Warehouse.Driver')" :disabled="txtEditEable" class="custom">
                <el-input
                  v-model="truckingInfo.driverName"
                  no="12"
                  style="width:350px;"
                  @blur="event => truckDataChange(event, 'driverName')"
                />
              </el-form-item>

              <el-form-item :label="$t('Warehouse.DriverPhone')" :disabled="txtEditEable" class="custom">
                <el-input
                  v-model="truckingInfo.driverPhone"
                  no="45"
                  :disabled="readonly"
                  style="width:350px;"
                  @blur="event => truckDataChange(event, 'driverPhone')"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CarryingCaseYard')" :disabled="txtEditEable" class="custom">
                <el-input
                  v-model="selectedData.truckingPlaceOfDep"
                  no="45"
                  :disabled="readonly"
                  style="width:350px;"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Door')" class="custom">
                <div style="display: flex; align-items: center;">
                  <cargo-advance-select
                    filterable
                    :cache="false"
                    :allow-create="true"
                    :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                    :disabled="readonly"
                    tag-name="name"
                    tag-value="name"
                    :default-value="truckingInfo.doorName"
                    :static-options="doorList"
                    :filter-tag-names="['name']"
                    style="width: 270px"
                    @parentCallBack="doorsChangeHandler"
                  />
                  <el-button v-show="$checkPermission(['button_Common_AddSite'])" no="addDoor" :disabled="!isEdit" class="vehicle-btn" type="primary" size="mini" @click="addDoor">{{ $t('Partners.doorInformation') }}</el-button>
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.DoorAddress')" class="custom">
                <el-input v-model="truckingInfo.doorAddr" no="16" type="textarea" :rows="3" style="width:350px" @blur="event => doorChangeHandler(event, 'doorAddr')" />
              </el-form-item>
              <el-form-item class="auto-width" label-width="0">
                <div style="display: flex;">
                  <el-form-item class="custom" :label="$t('Pricing.BelongingCity')">
                    <cargo-advance-select
                      no="17"
                      style="width:140px"
                      :disabled="readonly"
                      :tag-name="$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      :cache="false"
                      filterable
                      :default-value="truckingInfo.cityCode"
                      :static-options="cityList"
                      :placeholder="$t('SeaExport.PleaseSelect')"
                      @parentCallBack="p=>{truckingInfo.cityCode=p.value;cityChangeHandler(p.value)}"
                    />
                  </el-form-item>
                  <el-form label-width="100px" label-position="left">
                    <el-form-item class="custom" :label="$t('Warehouse.PalletSum')">
                      <el-input-number no="18" style="width:110px;" :value="truckingInfo.palletSum" :disabled="readonly" :min="0" :max="999999999999" :precision="0" :controls="false" @input="val=>{truckingInfo.palletSum=val || 0}" />
                    </el-form-item>
                  </el-form>
                </div>
              </el-form-item>

              <el-form-item label="PO">
                <el-input v-model="truckingInfo.po" no="po" :disabled="readonly" :filter-chars="false" type="textarea" :rows="3" style="width:350px" />
              </el-form-item>
            </el-form>

            <el-form label-width="140px" label-position="left">
              <el-form-item class="custom" :label="$t('SeaExport.HaulageNo')">
                <el-input
                  v-model="truckingInfo.truckOrderNo"
                  no="19"
                  :disabled="readonly"
                  style="width:140px"
                  @change="refreshGrid"
                />
                <label>{{ $t('SeaExport.HaulageCharge') }}</label>
                <el-input-number
                  v-model="truckingInfo.truckingFee"
                  no="40"
                  :disabled="readonly"
                  :min="0"
                  :max="999999999999"
                  :precision="2"
                  controls-position="right"
                  style="width:110px"
                  @change="truckingFeeCharge"
                />
                <span class="currency">{{ localCurrency }}</span>
              </el-form-item>

              <el-form-item class="custom" :label="$t('SeaExport.Tel')">
                <el-input v-model="truckingInfo.driverTel" no="41" :disabled="readonly" style="width:350px" @change="driverTelChargeHandler" />
              </el-form-item>

              <el-form-item class="custom" :label="$t('SeaExport.ActualPackingDate')">
                <el-date-picker
                  v-model="truckingInfo.actLoadingDate"
                  no="42"
                  :disabled="readonly"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width:350px"
                  @input="event => truckDataChange(event, 'actLoadingDate')"
                />
              </el-form-item>

              <el-form-item class="custom" :label="$t('SeaExport.ActualArrivalDate')">
                <el-date-picker
                  v-model="ieTruckInfo.actualArrivalDate"
                  no="actualArrivalDate"
                  :disabled="true"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width:350px"
                />
              </el-form-item>

              <el-form-item class="custom" :label="$t('CargoMsg.Cargo_VehicleModel')">
                <cargo-advance-select
                  no="vehicleType"
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_VehicleModel"
                  filterable
                  :method-params="{typeTc:true}"
                  style="width:350px;"
                  :clearable="false"
                  :default-value="job.vehicleType"
                  @parentCallBack="p=>{job.vehicleType=p.value;}"
                />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.PlateNumber')" class="custom">
                <el-input
                  v-if="isEdit"
                  v-model="truckingInfo.plateNumber"
                  no="43"
                  :disabled="readonly"
                  style="width:230px;"
                  @blur="event => truckDataChange(event, 'plateNumber')"
                  @input="(val)=>{truckingInfo.plateNumber = val.trim()}"
                />
                <span v-if="readonly" class="plate_number">{{ truckingInfo.plateNumber }}</span>
                <el-tooltip effect="light" :content="$t('SeaExport.ClickVehiclePositioningAndTrack')" placement="top">
                  <i class="el-icon-question vehicle-tip" />
                </el-tooltip>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.DriverIDCard')" class="custom">
                <el-input v-model="truckingInfo.driverIdCard" no="15" :disabled="readonly" style="width:350px" @blur="event => truckDataChange(event, 'driverIdCard')" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.ReturnYard')" class="custom">
                <el-input v-model="selectedData.truckingPlaceOfDest" no="15" :disabled="readonly" style="width:350px" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.DoorContactPerson')" class="custom">
                <el-input v-model="truckingInfo.doorMan" no="15" :disabled="readonly" style="width:350px" @blur="event => doorChangeHandler(event, 'doorMan')" />
              </el-form-item>
              <el-form-item class="custom" :label="$t('SeaExport.Tel')">
                <el-input v-model="truckingInfo.doorManTel" no="46" :disabled="readonly" style="width:350px" @blur="event => doorChangeHandler(event, 'doorManTel')" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.AdditionalNotes')">
                <el-input v-model="truckingInfo.remarks" no="47" :disabled="readonly" :filter-chars="false" type="textarea" :rows="3" style="width:350px" @blur="event => truckDataChange(event, 'remarks')" />
              </el-form-item>
              <el-form-item class="custom" :label="$t('SeaExport.travelTime')">
                <el-input-number
                  v-model="truckingInfo.travelHour"
                  :disabled="readonly"
                  no="13"
                  :min="0"
                  controls-position="right"
                  style="width:105px"
                />
                <span style="margin:10px">{{ $t('SeaExport.Hour') }}</span>
                <el-input-number
                  v-model="truckingInfo.travelMinute"
                  :disabled="readonly"
                  no="14"
                  :min="0"
                  :max="59"
                  controls-position="right"
                  style="width:100px"
                />
                <span style="margin:10px">{{ $t('SeaExport.Minute') }}</span>
              </el-form-item>
            </el-form>
          </div>

        </div>
        <el-form label-width="70px" label-position="left">
          <el-form-item class="custom" :label="$t('SeaExport.ContainerNo')">
            <el-input v-model="selectedData.containerNo" no="containerNo" :disabled="readonly" style="width:250px" @blur="event => truckDataChange(event, 'containerNo')" />
          </el-form-item>
          <el-form-item class="custom" :label="$t('SeaExport.SealNo')">
            <el-input v-model="selectedData.sealNo" no="sealNo" :disabled="readonly" style="width:250px" @blur="event => truckDataChange(event, 'sealNo')" />
          </el-form-item>
          <el-form-item class="custom" :label="$t('SeaExport.EmptyContainerWeight')">
            <el-input-number
              v-model="truckingInfo.containerWeight"
              no="7"
              :disabled="readonly"
              :min="0"
              :max="99999"
              :precision="3"
              controls-position="right"
              style="width: 200px"
              @input="event => truckDataChange(event, 'containerWeight')"
            /> KG
          </el-form-item>
        </el-form>
      </div>
      <!-- 门点信息公共弹窗 -->
      <door-point-information
        :v-if="addDoorDialog.visible"
        :visible.sync="addDoorDialog.visible"
        :action="action"
        :site="addDoorDialog.form"
        @loadSites="loadSites"
      />
    </div>

  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

import { DateAutoInitRuleManage } from '@/class/cargo/model/utils/DateAutoInitRuleManage'
import { Job } from '@/class/model/booking/Job'
import StrUtils from '@/utils/StrUtils'
import { Trucking } from '@/class/model/booking/Trucking'
import { Company } from '@/class/model/mdm/Company'
import { addSites, getSites } from '@/api/company'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import SoNoSelector from '@/components/Cargo/Job/soNoSelector'
import TuckOrderLogDialog from '@/components/Cargo/Job/tuckOrderLogDialog'
import { DocumentManage } from '@/utils/commonUtil'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import cargoRepeatValueSelect from '@/components/Cargo/Common/cargoRepeatValueSelect'
import moment from 'moment'
import { getLocationList } from '@/api/location'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import ContainerNoHelper from '@/utils/containerNoHelper'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { TabError } from '@/utils/class/TabError'
import { importTruckExcelData } from '@/api/seaExport/trucking'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import { Charge } from '@/class/model/act/Charge'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import URL from '@/api/urlTranslator'
import AddDoorDialog from '@/views/cargo/v0/SeaExport/components/booking/addDoorDialog.vue'
import { IntegratedTruckingInfo } from '@/class/model/booking/IntegratedTruckingInfo'
import DoorPointInformation from '@/views/cargo/v0/Information/components/partner/tab/doorPointInformation.vue'

export default {
  name: 'TabGatheringTrailer',
  components: {
    DoorPointInformation,
    AddDoorDialog,
    CargoDateTimeFieldInput, TuckOrderLogDialog, SoNoSelector, cargoAdvanceSelect, cargoCompanySelect,
    cargoRepeatValueSelect
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    from: {
      type: String,
      default: () => null
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: null,
      selectedData: {
        container: {}
      },
      addDoorDialog: {
        visible: false,
        form: {
          title: '',
          name: '',
          contact: '',
          phone: '',
          address: '',
          remarks: '',
          city: '',
          companyUuid: ''
        }
      },
      selectTypeNames: TYPE_NAMES,
      command1: this.$t('SeaExport.DispatchTuckOrder'),
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.selectionChangeHandler,
        frameworkComponents: {
          CargoAgGridDateTimeEditor
        }
      },
      rowData: [],
      gridApi: null,
      gridParams: {},
      currentUser: {},
      job: new Job().fillDefaultValue().getData(),
      cityList: [],
      truckingInfo: new Trucking().fillDefaultValue().getData(), // 初始化
      ieTruckInfo: new IntegratedTruckingInfo().fillDefaultValue().getData(), // 初始化
      soNo: '',
      gridVisible: {
        dgUsage: false
      },
      usages: [],
      isAllowGridClick: false, // 是否允许触发门点grid的点击事件
      needReloadDriver: false, // 切换公司时, 重新读取司机信息, 否则不读取
      neednotReloadTelephone: false, // 表格内切换门点时, 不按照联系人名称重新读取电话
      txtEditEable: false, // 编辑文本框是否允许编辑
      needSaveCustomer: false, // 是否需要更新job.customer
      txtTMSHint: '',
      carryingContacts: [],
      doorList: [],
      documentManage: new DocumentManage(),
      containerUsages: [], // 记录装箱明细
      containers: [], // 记录装箱信息
      importExcelResultID: '' // 导入多柜装箱信息结果文件ID
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    topConfigModuel() {
      return '130145'
    },
    cabinetColumnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerId'),
          field: 'containerId',
          width: 100,
          valueFormatter: (params) => {
            if (params.data.container) {
              return params.data.container.containerId
            }
            return ''
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 100,
          valueFormatter: (params) => {
            return this.subClassLabelFunction(params.data, 'eqSize')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 100,
          valueFormatter: (params) => {
            return this.subClassLabelFunction(params.data, 'eqType')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 100,
          cellStyle: (params) => {
            return this.containerNbrStyleFunction(params)
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 100,
          cellStyle: (params) => {
            return this.sealNoStyleFunction(params)
          }
        },
        {
          headerName: this.$t('SeaExport.DriverName'),
          field: 'tosDriverName',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.DriverPhone'),
          field: 'tosDriverPhone',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.DriverId'),
          field: 'tosTaskId',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.TruckNo'),
          field: 'tosCarNum',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'containerWeight',
          width: 100,
          cellRenderer: (params) => {
            if (params.data.container) {
              return ColumnUtils.number3ColumnLabelFunc(params.data.container.containerWeight)
            }
            return ''
          }
        },
        {
          headerName: this.$t('SeaExport.truckingPlaceDep'),
          field: 'truckingPlaceOfDep',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.truckingPlaceDest'),
          field: 'truckingPlaceOfDest',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.EstimatedPackingDate'),
          field: 'tosInTime',
          width: 160,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ActualPackingDate'),
          field: 'tosGinTime',
          width: 160,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 110,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.AdditionalNotes'),
          field: 'tosLocation',
          width: 120
        }, {
          headerName: this.$t('SeaExport.ExpectedArrivalDate2'),
          field: 'arriveDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ActualArrivalDate'),
          field: 'actualArrivalDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }
      ]
    },
    sessionId() {
      return this.$store.getters.token
    },
    localCurrency() {
      return RateUtil.localCurrencyByOffice()
    }
  },
  watch: {
    topConfigModuel() {
      this.top.visible = false
      this.$nextTick(() => {
        this.top.visible = true
      })
    }
  },
  async created() {
    this.cityList = await getLocationList({ paging: false }).then((res) => {
      return res.data.list || []
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.job = row
      this.loadSites()
      if (!isRefresh) {
        return
      }
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.currentUser = cache.user
      // 加载数据
      const job = new IntegratedJob(row)
      if (this.readonly || !job.trucking || job.trucking.length <= 0) {
        job.trucking = ''
      }
      if (this.readonly) {
        job.containers = ''
      }
      if (this.readonly) {
        job.containerUsages = ''
      }
      await Promise.all([
        job.getTrucking(),
        job.getContainers(),
        job.getContainerUsages()
      ])
      this.trucking = job.trucking
      // 默认显示一个箱子数据
      if (this.job.containerUsages && this.job.containerUsages.length > 0) {
        const containerUsages = this.job.containerUsages
        // 按照箱ID升序
        containerUsages.sort((a, b) => { return a.container.containerId - b.container.containerId })
        for (const usage of containerUsages) {
          if (usage.truckingInfoUuid) {
            const trucking = this.trucking.filter(p => p.uuid === usage.truckingInfoUuid)
            if (trucking && trucking[0].integratedTruckingInfo) {
              usage.arriveDate = trucking[0].integratedTruckingInfo.arriveDate
              usage.actualArrivalDate = trucking[0].integratedTruckingInfo.actualArrivalDate
            }
          }
        }
        this.job.containerUsages = containerUsages
        const cu = this.job.containerUsages[0]
        this.doSelectionChangeHandler(cu)
      }
    },
    // 门店地址
    async loadSites() {
      // 同步实现 loadSiteResultHandler
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      if (!companyCache) return
      const companyUuid = companyCache.uuid
      if (!companyUuid) return
      await getSites(companyUuid).then(res => {
        this.doorList = res.data
      })
    },
    async autoCalculateDateRule() {
      await DateAutoInitRuleManage.getInstance().autoCalculateDateRule(this.job, this.truckingInfo, 'IE')
    },
    selectionChangeHandler(event) {
      if (!event.data) {
        return
      }
      this.doSelectionChangeHandler(event.data)
    },
    doSelectionChangeHandler(cu) {
      // 选中箱数据
      this.selectedData = cu
      this.addTruckInfo(cu)
      this.neednotReloadTelephone = true
      this.txtEditEable = this.isEdit && (this.truckingInfo.sendState === 0)
      this.fillView()
      this.refreshGrid()
    },
    addTruckInfo(cu) {
      // 检查箱子是否有挂在客户门点
      // 如果没有关联客户门点，新增一个门点
      let newData = true
      if (cu.truckingInfoUuid && this.job && this.job.trucking &&
        this.job.trucking.length > 0) {
        const data = this.job.trucking.find(p => p.uuid === cu.truckingInfoUuid)
        if (data) {
          newData = false
          this.truckingInfo = data
          if (this.truckingInfo.integratedTruckingInfo) {
            this.ieTruckInfo = this.truckingInfo.integratedTruckingInfo
          } else {
            // 兼容部分客户门点没有扩展表情况
            this.ieTruckInfo = this.truckingInfo.integratedTruckingInfo = new IntegratedTruckingInfo().fillDefaultValue().getData()
          }
        }
      }
      if (newData) {
        this.addHandler(cu)
      }
    },
    fillView() {
      if (!this.truckingInfo) return
      this.carringCapChange()
      this.refreshGrid()
    },
    // change carrying company
    async carringCapChange() {
      // 同步实现 carryingContactResultHandler
      if (!this.truckingInfo || this.truckingInfo.carryingCmp <= 0) return
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.truckingInfo.carryingCmp))
      if (!companyCache) {
        this.truckingInfo.carryingCmp = 0
        this.isNullData()
        return
      }
      const company = new Company({ cmpIdx: this.truckingInfo.carryingCmp })
      if (!company) return
      this.carryingContacts = await company.getContactsBycmpIdx()

      if (this.carryingContacts && this.carryingContacts.length > 0) {
        if (!this.truckingInfo.driver) {
          this.truckingInfo.driver = this.carryingContacts[0].contactPerson
        }
      } else {
        this.isNullData()
      }
      if (!this.truckingInfo.driver) return
      this.carryingContactsChangeHandler(this.needReloadDriver, this.neednotReloadTelephone)
    },
    isNullData() {
      this.carryingContacts = []
      this.truckingInfo.driver = ''
      this.truckingInfo.driverTel = ''
    },
    carryingContactsChangeHandler(needReloadDriver = false, needNotReloadTelephone = false) {
      if (!this.truckingInfo || !this.truckingInfo.driver) return
      this.neednotReloadTelephone = needNotReloadTelephone
      this.needReloadDriver = needReloadDriver
      // console.log('======================', value, this.carryingContacts, contact)
      if (this.carryingContacts && this.carryingContacts.length > 0) {
        for (const item of this.carryingContacts) {
          if (item && item.contactPerson && item.contactPerson === this.truckingInfo.driver) {
            if (!this.neednotReloadTelephone) {
              this.truckingInfo.driverTel = item.telephone
              break
            }
          }
        }
      } else {
        const contacts = this.carryingContacts
        if (contacts && contacts.length > 0 && this.needReloadDriver) {
          const cat = contacts[0]
          this.truckingInfo.driver = cat.contactPerson
          this.truckingInfo.driverTel = cat.telephone
        } else {
          this.truckingInfo.driver = ''
          if (this.needReloadDriver) {
            this.truckingInfo.driverTel = ''
          }
        }
      }
      this.synchronizationData()
      this.refreshGrid()
    },
    /**
     * 验证
     */
    validate() {
      if (!this.job || !this.job.containerUsages || !this.isEdit) {
        return true
      }
      const msg = ContainerUtil.validateContainerUsage(this.job)
      if (msg) {
        throw new TabError(msg, 'tabGatheringTrailer')
      }
      return true
    },
    // 新增
    addHandler(cu) {
      if (this.truckingInfo && this.isEdit) {
        this.fillModel()
      }
      if (this.validate()) {
        const trucking = ContainerUtil.doCreateTrucking(cu, this.job)
        trucking.integratedTruckingInfo = new IntegratedTruckingInfo().fillDefaultValue().getData()
        this.ieTruckInfo = this.truckingInfo.integratedTruckingInfo
        this.trucking.push(trucking)
        this.truckingInfo = trucking
        this.$nextTick(() => {
          this.refreshGrid()
        })
      }
    },
    // 拖车费
    truckingFeeCharge() {
      if (this.truckingInfo && this.isEdit) {
        this.createCharge(true)
      }
    },
    async createCharge(isFinal) {
      if (!this.truckingInfo.truckingFee) {
        this.$nextTick(() => {
          this.truckingInfo.truckingFee = 0
        })
      }
      if (!isFinal) {
        return
      }
      const chargeCount = this.getCost()
      const amount = this.truckingInfo.truckingFee
      const truckingCount = this.job.trucking ? this.job.trucking.length : 0
      let charge = null
      let isCreate = true
      if (this.job.charges && this.job.charges.length > 0) {
        for (const c of this.job.charges) {
          if (c.truckOrderNo === this.truckingInfo.truckOrderNo) {
            isCreate = false
            charge = c // 先录费用后录拖车使用
            break
          }
        }
      }
      const chargeItemId = parseInt(cache.config.get('TruckingFeeCode')) // TRUCKING_FEE_CODE;
      const chargeItem = ChargeItem.getChargeItemById(chargeItemId)
      if (chargeItem && chargeItem.active && truckingCount > chargeCount && amount > 0 && isCreate) {
        charge = this.createNewCharge()
        charge.truckOrderNo = this.truckingInfo.truckOrderNo
        charge.chargeItemId = chargeItemId // TRUCKING_FEE_CODE;
        if (chargeItem.taxRate > 0) {
          charge.taxRate = chargeItem.taxRate
        }
        if (chargeItem.measure !== null && chargeItem.measure !== '') {
          charge.measure = chargeItem.measure
        }
        charge.unitPriceIncludeTax = parseInt(cache.config.get('InputIncludingTaxUnitPrice')) === 2
        // 其他tab 有charge 提交 需合并或其他方案待处理
        if (!this.job.charges) {
          this.job.charges = []
        }
        charge.serialNumber = this.job.charges.filter(p => !p.receivable).length + 1
        charge.isDirty = true
        this.job.charges.push(charge)
      }
      const shared = charge && (charge.shared || (charge.shareScheme && parseInt(charge.shareScheme) !== 0)) // 是否已分摊
      if (charge && charge.verifiedAmount === 0 && StrUtils.isEmpty(charge.billingUuid) && StrUtils.isEmpty(charge.billingPaymentUuid) && StrUtils.isEmpty(charge.invoiceUuid)) {
        if (!isNaN(amount) && amount > 0) {
          charge.accountId = this.truckingInfo.carryingCmp
          if (charge.uuid) {
            if (charge.chargeState === 0 && !charge.confirmState && !this.job.payableChargeLockedStatus && !shared) {
              charge.unitRate = amount
            }
          } else {
            charge.unitRate = amount
          }
          ChargeUtils.calculateTax(charge, parseFloat((charge.unitRate * charge.quantity).toFixed(2)), charge.taxRate, true)
          charge.isDirty = true
        }
      }

      // 设置开票抬头
      if (charge && charge.accountId && charge.accountId > 0) {
        await ChargeUtils.updateDefaultInvoiceTitle([charge])
      }
      this.context.reloadCharge = true
    },
    createNewCharge() {
      const charge = new Charge().fillDefaultValue().getData()
      charge.jobUuid = this.job.uuid
      charge.businessDate = this.job.businessDate
      charge.quantity = 1
      charge.localCurrency = this.localCurrency
      charge.currency = this.localCurrency
      charge.exchangeRate = 1
      charge.measure = 'NML'
      charge.receivable = false
      charge.oversea = false
      charge.verifiedAmount = 0
      charge.inputDate = new Date()
      charge.inputBy = this.currentUser.userId
      charge.branchId = this.$store.getters.currentOfficeId

      charge.inputByDep = this.job.opDepartment
      charge.businessDate = this.job.businessDate

      // 此处增加标识，费用页签再保存会导致费用重复生成
      charge.createdByOther = true
      return charge
    },
    // get job's trucking charge
    getCost() {
      // TRUCKING_FEE_CODE  默认拖车费
      const chargeCode = parseInt(cache.config.get('TruckingFeeCode'))
      let count = 0
      for (const charge of this.job.charges) {
        if (charge.chargeItemId === chargeCode && !charge.receivable) {
          count++
        }
      }
      return count
    },
    doorsChangeHandler(option) {
      this.truckingInfo.doorName = option.name
      // 勾选了门点相同时，默认全部使用统一门点
      if (this.truckingInfo.sameDoorPoint) {
        for (const data of this.trucking) {
          if (data.sameDoorPoint) {
            this.doDoorsChangeHandler(data, option)
          }
        }
      }
      this.refreshGrid()
    },
    doDoorsChangeHandler(truckingInfo, option) {
      if (option) {
        truckingInfo.doorName = option.name
        truckingInfo.doorMan = option.contact
        truckingInfo.doorManTel = option.phone
        truckingInfo.doorAddr = option.address
        if (option.remarks) {
          truckingInfo.remarks = option.remarks
        }
      }
      this.refreshGrid()
    },
    doorChangeHandler(event, name) {
      if (this.truckingInfo.sameDoorPoint) {
        for (const data of this.trucking) {
          if (data.sameDoorPoint) {
            switch (name) {
              case 'doorName':
                data.doorName = event.target.value
                break
              case 'doorMan':
                data.doorMan = event.target.value
                break
              case 'doorManTel':
                data.doorManTel = event.target.value
                break
              case 'doorAddr':
                data.doorAddr = event.target.value
                break
            }
          }
        }
      }
    },
    // 运输公司
    async carryingCmpChangeHandler() {
      if (!this.truckingInfo) return
      this.neednotReloadTelephone = false
      this.needReloadDriver = true
      this.job.carryingCmp = this.truckingInfo.carryingCmp
      this.truckingInfo.driver = ''
      this.truckingInfo.driverTel = ''
      this.carryingContacts = []
      await this.carringCapChange()
      this.synchronizationData()
      this.refreshGrid()
      this.truckingFeeCharge()
    },
    // 所在城市
    async cityChangeHandler(value) {
      if (!this.truckingInfo) return
      // 勾选了门点相同时，其他勾选了也同步更新下
      if (this.truckingInfo.sameDoorPoint) {
        for (const data of this.trucking) {
          if (data.sameDoorPoint) {
            data.cityCode = value
          }
        }
      }
      this.refreshGrid()
    },
    synchronizationData() {
      // 勾选了运输公司相同时，其他勾选了也同步更新下
      if (this.truckingInfo.sameTransportationCompany) {
        for (const data of this.trucking) {
          if (data.sameTransportationCompany) {
            data.driver = this.truckingInfo.driver
            data.driverTel = this.truckingInfo.driverTel
            data.carryingCmp = this.truckingInfo.carryingCmp
          }
        }
      }
    },
    driverTelChargeHandler() {
      if (!this.truckingInfo) return
      this.synchronizationData()
      this.refreshGrid()
    },
    getSubmitData() {
      this.validateForm()
      this.fillModel()
      const job = { ...this.job }
      job.trucking = this.trucking
      const charges = []
      if (this.job.charges && this.job.charges.length > 0) {
        for (const charge of this.job.charges) {
          if (!charge.isDirty) continue
          charges.push(charge)
        }
      }
      const result = {
        job,
        containerUsages: this.job.containerUsages,
        containers: this.job.containers.filter(p => p.isDirty === true),
        truckingInfo: job.trucking
      }
      if (charges.length > 0) result.charges = charges
      return result
    },
    validateForm() {
      if (this.truckingInfo.truckingFee && !this.truckingInfo.carryingCmp) {
        throw new TabError(this.$t('Message.PleaseEnterTheShippingCompanyInformation'), 'tabGatheringTrailer')
      }
    },
    fillModel() {
      // 判断门点 手工输入非 选择
      const door = this.doorList.find(item => item.name === this.truckingInfo.doorName)
      if (!door) { // new door
        this.needSaveCustomer = true
        this.newDoor()
      }
      this.truckingInfo.soNo = ''
      this.createCharge(false)
    },
    newDoor() {
      if (!this.job.customerId || this.job.customerId === 0) {
        return
      }
      if (!this.truckingInfo.doorName) {
        return
      }
      // 填写内容是下拉框中的数据源
      const inputDoor = this.doorList.find(p => p.name === this.truckingInfo.doorName)
      if (inputDoor) {
        return
      }

      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      const door = {
        name: this.truckingInfo.doorName,
        contact: this.truckingInfo.doorMan,
        phone: this.truckingInfo.doorManTel,
        address: this.truckingInfo.doorAddr,
        companyUuid: companyCache.uuid
      }
      addSites(door)
    },
    refreshGrid() {
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true })
      }
    },
    selectContactBlur(event) {
      if (event && event.target && event.target.value) {
        this.truckingInfo.driver = event.target.value
      }
      this.refreshGrid()
    },
    endTabHandler() {
      this.job.truckingPage = true
    },
    // 预计出仓时间、预计进港时间显示
    estimatedDisplayFunction(params, field) {
      if (params.data && params.data.container) {
        const tempTime = params.data.container[field]
        return tempTime ? ColumnUtils.dateTimeLabelFunc(tempTime) : ''
      }
      return ''
    },
    // 多柜模式-导出做箱信息
    exportTruckExcelData() {
      ExportUtils.downloadIntegratedTruckExcelTemplate('IECustomerStoreImportTemplate.xls', this.job.uuid)
    },
    // 多柜模式-下载导入结果
    exportErrorExcel() {
      // 从云存储上下载文件
      if (!this.importExcelResultID) {
        this.$message.warning(this.$t('SeaExport.NoCorrespondingFile'))
        return
      }
      const storageURL = cache.config.get('StorageURL')
      const url = `${URL.common.findByFileId}/${this.importExcelResultID}?sessionId=${this.sessionId}`
      window.open(url)
    },
    beforeUploadUsage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // 多柜模式-导入做箱信息
    importTruckDataExcel(item) {
      const params = {
        file: item.file,
        jobUuid: this.job.uuid
      }
      importTruckExcelData(params).then(res => {
        if (res.data) {
          this.importExcelResultID = res.data
          this.$message.success(this.$t('SeaExport.ImportSuccess'))
        } else {
          this.$message.success(this.$t('SeaExport.ImportFailedContactAdministrator'))
        }
        this.onShow(this.job, true)
      })
    },
    // 客户门点信息变更 同步箱子
    truckDataChange(event, name) {
      switch (name) {
        case 'containerNo':
          this.selectedData.containerNo = event.target.value
          if (this.selectedData.container) {
            this.selectedData.container.containerNo = event.target.value
            if (this.job.containers) {
              for (const container of this.job.containers) {
                if (container.uuid === this.selectedData.container.uuid) {
                  container.containerNo = event.target.value
                  container.isDirty = true
                }
              }
            }
          }
          break
        case 'sealNo':
          this.selectedData.sealNo = event.target.value
          if (this.selectedData.container) {
            this.selectedData.container.sealNo = event.target.value
            if (this.job.containers) {
              for (const container of this.job.containers) {
                if (container.uuid === this.selectedData.container.uuid) {
                  container.sealNo = event.target.value
                  container.isDirty = true
                }
              }
            }
          }
          break
        case 'driverName':
          this.selectedData.tosDriverName = event.target.value
          break
        case 'driverPhone':
          this.selectedData.tosDriverPhone = event.target.value
          break
        case 'plateNumber':
          this.selectedData.tosCarNum = event.target.value
          break
        case 'driverIdCard':
          this.selectedData.tosTaskId = event.target.value
          break
        case 'loadingDate':
          this.selectedData.tosInTime = event
          break
        case 'actLoadingDate':
          this.selectedData.tosGinTime = event
          break
        case 'remarks':
          this.truckingInfo.remarks = event.target.value
          this.selectedData.tosLocation = event.target.value
          break
        case 'containerWeight':
          if (isNaN(event)) {
            event = 0
          }
          this.truckingInfo.containerWeight = event
          this.selectedData.container.containerWeight = event
          break
        case 'quantity':
          if (isNaN(event)) {
            event = 0
          }
          this.truckingInfo.quantity = event
          this.selectedData.quantity = event
          // 同步下件毛体到基本页签
          ContainerUtil.refContainerUsageQwc(this.job, 1)
          break
        case 'weight':
          if (isNaN(event)) {
            event = 0
          }
          this.truckingInfo.weight = event
          this.selectedData.weight = event
          // 同步下件毛体到基本页签
          ContainerUtil.refContainerUsageQwc(this.job, 1)
          break
        case 'cubage':
          if (isNaN(event)) {
            event = 0
          }
          this.truckingInfo.cubage = event
          this.selectedData.cubage = event
          // 同步下件毛体到基本页签
          ContainerUtil.refContainerUsageQwc(this.job, 1)
          break
      }
      this.refreshGrid()
    },
    // 组装打印参数
    getPrintData() {
      const containerUsages = this.gridApi.getSelectedRows()
      if (!containerUsages || containerUsages.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      const params = {}
      const uids = []
      for (const c of containerUsages) {
        if (c.container && c.container.uuid && !uids.includes(c.container.uuid)) {
          uids.push(c.container.uuid)
        }
      }
      params.CONTAINER_UUID = uids
      params.category = 'IE_CONTAINER_LIST'
      params.ctx = new IntegratedJob(this.job)
      this.$logger.log('params', params)
      return params
    },
    subClassLabelFunction(data, fieldName) {
      if (fieldName === 'eqSize') {
        const eqSize = data.container ? EQSize.getEQSizeByCode(data.container[fieldName]) : null
        return eqSize === null ? '' : eqSize.name
      } else {
        if (!data.container) return ''
        return data.container[fieldName] || ''
      }
    },
    containerNbrStyleFunction(params) {
      const usage = params.data
      if (usage.container) {
        if (usage && !ContainerNoHelper.checkContainerNo(params.value)) {
          return { color: '#F56C6C' }
        }
        if (DataPushCompareUtils.comparePushData(this.$t('SeaExport.ContainerNo'), params.value, usage.container.uuid)) {
          return { color: '#1F75D5' }
        }
      }
      return { color: '' }
    },
    sealNoStyleFunction(params) {
      const usage = params.data
      if (usage.container) {
        if (usage.isReSealed) {
          return { color: '#F56C6C' }
        }
        if (DataPushCompareUtils.comparePushData(this.$t('SeaExport.SealNo'), params.value, usage.container.uuid)) {
          return { color: '#1F75D5' }
        }
      }
      return { color: '' }
    },
    // 新增门点弹框
    addDoor() {
      if (!this.job.customerId || this.job.customerId === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectCommissioningUnit'))
        return
      }
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      if (!companyCache) return
      const companyUuid = companyCache.uuid
      if (!companyUuid) return
      this.addDoorDialog.form = {
        companyUuid: companyUuid,
        companyName: this.$store.getters.language === 'zh' ? companyCache.chineseName : companyCache.englishName
      }
      this.addDoorDialog.visible = true
    }
  }

}
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
.inline-form{
  margin-left: 20px;
  label{
    font-weight: normal;
  }
  .el-form-item__content{
    & > label{
      width: 40px;
      display: inline-block;
      &:first-of-type{
        margin-left: 1px;
      }
    }
    .el-input-number{
      width: 86px;
      margin-right: 10px;
    }
  }
  .el-form-item{
    &:nth-of-type(2){
      margin-left: 70px;
    }
    /deep/ .so-no-selector{
      & > span{
        &:first-of-type{
          flex: 1;
        }
      }
    }
  }
}
.trucking-form{
  width: 1100px;
  box-sizing: border-box;
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  .el-form{
    flex: 1;
    .el-form-item__content{
      & > label{
        margin: 0 10px;
        font-weight: normal;
      }
      span{
        &.currency{
          margin-left: 10px;
        }
      }
    }
    .plate_number{
      width: 230px;
      height: 28px;
      box-sizing: border-box;
      padding-left: 10px;
      vertical-align: middle;
      background-color: #f3f4f5;
      border: 1px solid #E4E7ED;
      color: blue;
      text-decoration: underline;
      cursor: pointer;
      display: inline-block;
    }
    .vehicle-btn{
      margin-left: 10px;
    }
    .vehicle-tip{
      margin-left: 5px;
      font-size: 16px;
      color: #1F75D5;
    }
  }
}

</style>
